import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { UnshareNotePayload } from '@nx-frontend/shared/types';

export async function unshareNote({ userId, workspaceId, noteId }: UnshareNotePayload): Promise<void> {
  const host = generalEnv.noteServiceUrl;
  await axiosClient.delete(`${host}/v1/workspaces/${workspaceId}/notes/${noteId}/share`, {
    userId,
  });
}
